/*
 * @Descripttion : 路由列表
 */

import routerAboutCar from './routerAboutCar';
import routerMarketing from './routerMarketing';
import routerStaticPage from './routerStaticPage';
import routerSharePage from './routerSharePage';
import routerInstall from './routerInstall';
import routerAuction from './routerAuction';

let routes = [
  ...routerAboutCar,
  ...routerMarketing,
  ...routerStaticPage,
  ...routerSharePage,
  ...routerInstall,
  ...routerAuction
];


export default routes;